var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoiGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6164_8791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.16797L8.75 4.66797",
    stroke: "#4D5557",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54167 5.2513C5.70275 5.2513 5.83333 5.12072 5.83333 4.95964C5.83333 4.79855 5.70275 4.66797 5.54167 4.66797C5.38058 4.66797 5.25 4.79855 5.25 4.95964C5.25 5.12072 5.38058 5.2513 5.54167 5.2513Z",
    fill: "black",
    stroke: "#4D5557",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45829 8.16536C8.61938 8.16536 8.74996 8.03478 8.74996 7.8737C8.74996 7.71261 8.61938 7.58203 8.45829 7.58203C8.29721 7.58203 8.16663 7.71261 8.16663 7.8737C8.16663 8.03478 8.29721 8.16536 8.45829 8.16536Z",
    fill: "black",
    stroke: "#4D5557",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91663 12.25V2.91667C2.91663 2.60725 3.03954 2.3105 3.25833 2.09171C3.47713 1.87292 3.77387 1.75 4.08329 1.75H9.91663C10.226 1.75 10.5228 1.87292 10.7416 2.09171C10.9604 2.3105 11.0833 2.60725 11.0833 2.91667V12.25L9.33329 11.0833L8.16663 12.25L6.99996 11.0833L5.83329 12.25L4.66663 11.0833L2.91663 12.25Z",
    stroke: "#4D5557",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6164_8791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoiGrey);
export default __webpack_public_path__ + "static/media/roiGrey.6c7c88ef706082ec60864f8e28237389.svg";
export { ForwardRef as ReactComponent };